module.exports = __webpack_public_path__ + "static/img/semi.4eade5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/semi.png
// module id = 225
// module chunks = 170